<div class="accordions-container row">
  <div class="accordion-container col-md-12 col-lg-6 col-xxxl-6">
    <nb-card>
      <nb-card-header>Toggle Accordion By Button</nb-card-header>
      <nb-card-body>
        <button nbButton (click)="toggle()">Toggle First Item</button>
      </nb-card-body>
    </nb-card>

    <nb-accordion>
      <nb-accordion-item #item>
        <nb-accordion-item-header>
          Product Details
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          A nebula is an interstellar cloud of dust, hydrogen, helium and other ionized gases.
          Originally, nebula was a name for any diffuse astronomical object,
          including galaxies beyond the Milky Way.
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item>
        <nb-accordion-item-header>
          Reviews
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          A nebula is an interstellar cloud of dust, hydrogen, helium and other ionized gases.
          Originally, nebula was a name for any diffuse astronomical object,
          including galaxies beyond the Milky Way.
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item>
        <nb-accordion-item-header>
          Edit
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          A nebula is an interstellar cloud of dust, hydrogen, helium and other ionized gases.
          Originally, nebula was a name for any diffuse astronomical object,
          including galaxies beyond the Milky Way.
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </div>

  <div class="accordion-container col-md-12 col-lg-6 col-xxxl-6">
    <nb-accordion multi>
      <nb-accordion-item>
        <nb-accordion-item-header>
          Product Details
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          A nebula is an interstellar cloud of dust, hydrogen, helium and other ionized gases.
          Originally, nebula was a name for any diffuse astronomical object,
          including galaxies beyond the Milky Way.
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item>
        <nb-accordion-item-header>
          Reviews
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          A nebula is an interstellar cloud of dust, hydrogen, helium and other ionized gases.
          Originally, nebula was a name for any diffuse astronomical object,
          including galaxies beyond the Milky Way.
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item>
        <nb-accordion-item-header>
          Edit
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          A nebula is an interstellar cloud of dust, hydrogen, helium and other ionized gases.
          Originally, nebula was a name for any diffuse astronomical object,
          including galaxies beyond the Milky Way.
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </div>
</div>
